import type { Nullable } from "@core/domain/types/nullable.type";
import {
    IsDateString,
    IsNotEmpty,
    IsNumber,
    IsOptional,
    IsString,
} from "class-validator";

export class MedicalLeavePeriodDto {
    @IsNumber()
    @IsOptional()
    id?: number;

    @IsNumber()
    @IsOptional()
    termination?: number;

    @IsDateString()
    @IsNotEmpty()
    start_date!: string;

    @IsDateString()
    @IsNotEmpty()
    end_date!: string;

    @IsString()
    @IsNotEmpty()
    company_salary_percentage!: string;

    @IsString()
    @IsNotEmpty()
    project_imputable_percentage!: string;

    @IsString()
    @IsOptional()
    observations!: Nullable<string>;
}
